import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

// import css files
import './assets/app.min.css'